import { useNavigate } from 'react-router-dom';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { Button } from '@/components/ui/button';
import accessDeniedAnimation from '@/assets/access-denied.lottie';

export default function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 p-8">
      <DotLottieReact src={accessDeniedAnimation} loop autoplay className="h-64 w-64" />
      <div className="text-center">
        <h1 className="text-2xl font-bold">Access Denied</h1>
        <p className="text-muted-foreground mt-2">You do not have permission to access this page.</p>
      </div>
      <Button onClick={() => navigate('/')} variant="default">
        Go to Dashboard
      </Button>
    </div>
  );
}
